/**
 * Validation rules
 *
 * Based on original rules: https://bitbucket.org/flooris/brekz-2016/src/5802b7b6d41675ba7c533906791ff89c2fedea72/web/themes/brekz-2017/resources/js/checkout_field_validation.js?at=master#lines-161:234
 */
const ID_COUNTRY_GERMANY = 1;
const ID_COUNTRY_AUSTRIA = 2;
const ID_COUNTRY_BELGIUM = 3;
const ID_COUNTRY_FRANCE = 8;
const ID_COUNTRY_ITALY = 10;
const ID_COUNTRY_LUXEMBOURG = 12;
const ID_COUNTRY_NETHERLANDS = 13;
const ID_COUNTRY_DENMARK = 20;
const ID_COUNTRY_SWITZERLAND = 19;
const ID_COUNTRY_SWEDEN = 18;

export default {
    zipCode(zipCode, model) {
        let regex;

        switch(parseInt(model.id_country)) {
            case ID_COUNTRY_GERMANY:
            case ID_COUNTRY_ITALY:
            case ID_COUNTRY_SWEDEN:
                regex = /^(\d{5})$/i;
                break;
            case ID_COUNTRY_AUSTRIA:
            case ID_COUNTRY_BELGIUM:
            case ID_COUNTRY_DENMARK:
            case ID_COUNTRY_LUXEMBOURG:
            case ID_COUNTRY_SWITZERLAND:
                regex = /^(\d{4})$/i;
                break;
            case ID_COUNTRY_FRANCE:
                regex = /^(\d{2}[ ]?\d{3})$/i;
                break;
            case ID_COUNTRY_NETHERLANDS:
                regex = /^(\d{4}[ ]?[A-Z]{2})$/i;
                break;
            default:
                return false;
        }

        return regex.test(zipCode);
    },
    email(email) {
        const regex = /^[a-z\u00DF\u00E0-\u00FF0-9+\/=?^`{}|~_-]+[.a-z0-9+\/=?^`{}|~_-]*@[a-z0-9]+[._a-z\p{L}0-9-]*\.[a-z0-9]+$/i;

        return regex.test(email);
    },
    name(name) {
        const regex = /^([a-z\u00DF\u00E0-\u00FF0-9\.\s,'’-]{1,35})$/i;

        return regex.test(name);
    },
    address(address, model) {
        const regex = /^([a-zA-Z0-9\x7f-\xff\-\s,'-.\/]{1,35})\s?$/i;


        return regex.test(address);
    },
    houseNumber(houseNumber, model) {
        if (houseNumber === '' && model.address2 !==  ''){
            return true;
        }

        if (model.id_country === ID_COUNTRY_FRANCE) {
            return true;
        }

        const regex = /^\d{1,4}[\w \-\/\\]*?$/i

        return regex.test(houseNumber)
    },
    city(city) {
        const regex = /^([a-z\u00DF\u00E0-\u00FF\s,'-.]{2,35})$/i;
        return regex.test(city);
    },
    phone(phone) {
        if (phone === "") {
            return true;
        }
        const regex = /^([+0-9./ ()-]{6,20})$/i;
        return regex.test(phone);
    },
    password(password) {
        const regex = /^(.{5,30})$/i;
        return regex.test(password);
    },
    dayOfBirth(day) {
        return !(day < 1 || day > 31);
    },
    monthOfBirth(month) {
        return !(month < 1 || month > 12);
    },
    yearOfBirth(year) {
        const current_year = (new Date()).getFullYear();
        return !(year < 1900 || year > current_year);
    }
}
